import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbNavProps {
  items: Crumb[];
}

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    name: item.label,
    item: item.href ? `https://goblin-cave-guide.readdy.site${item.href}` : undefined,
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
                )}
                {item.href && !isLast ? (
                  <Link
                    to={item.href}
                    className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className={isLast ? 'text-foreground-900 font-medium' : 'text-foreground-500'}>
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}